export default __webpack_public_path__ + "static/media/search.4d59aa79.svg";